import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const StatusMessagesConfig = ({ 
  onlineMessage, 
  offlineMessage, 
  onOnlineMessageChange, 
  onOfflineMessageChange 
}) => {
  const maxLength = 50;
  const onlineRemaining = maxLength - onlineMessage?.length;
  const offlineRemaining = maxLength - offlineMessage?.length;

  const defaultMessages = {
    online: [
      "Wir sind online und bereit zu helfen!",
      "Unser Team ist verfügbar",
      "Live-Support aktiv",
      "Sofortige Hilfe verfügbar",
      "Online und bereit für Sie"
    ],
    offline: [
      "Wir sind momentan offline",
      "Außerhalb der Geschäftszeiten",
      "Hinterlassen Sie eine Nachricht",
      "Wir melden uns bald zurück",
      "Derzeit nicht verfügbar"
    ]
  };

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-foreground">Status-Nachrichten</h3>
      <div className="grid md:grid-cols-2 gap-6">
        {/* Online Message */}
        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 bg-success rounded-full"></div>
            <h4 className="font-medium text-foreground">Online-Status</h4>
          </div>
          
          <Input
            label="Online-Nachricht"
            type="text"
            value={onlineMessage}
            onChange={(e) => onOnlineMessageChange(e?.target?.value)}
            placeholder="z.B. Wir sind online und bereit zu helfen!"
            maxLength={maxLength}
            description={`${onlineRemaining} Zeichen verbleibend`}
            error={onlineRemaining < 0 ? 'Nachricht ist zu lang' : ''}
          />
          
          <div className="space-y-2">
            <p className="text-xs font-medium text-muted-foreground">Vorschläge:</p>
            <div className="space-y-1">
              {defaultMessages?.online?.map((message, index) => (
                <button
                  key={index}
                  onClick={() => onOnlineMessageChange(message)}
                  className="block w-full text-left p-2 text-xs text-muted-foreground hover:text-foreground hover:bg-muted rounded border border-transparent hover:border-border transition-all duration-200"
                >
                  {message}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Offline Message */}
        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 bg-muted-foreground rounded-full"></div>
            <h4 className="font-medium text-foreground">Offline-Status</h4>
          </div>
          
          <Input
            label="Offline-Nachricht"
            type="text"
            value={offlineMessage}
            onChange={(e) => onOfflineMessageChange(e?.target?.value)}
            placeholder="z.B. Wir sind momentan offline"
            maxLength={maxLength}
            description={`${offlineRemaining} Zeichen verbleibend`}
            error={offlineRemaining < 0 ? 'Nachricht ist zu lang' : ''}
          />
          
          <div className="space-y-2">
            <p className="text-xs font-medium text-muted-foreground">Vorschläge:</p>
            <div className="space-y-1">
              {defaultMessages?.offline?.map((message, index) => (
                <button
                  key={index}
                  onClick={() => onOfflineMessageChange(message)}
                  className="block w-full text-left p-2 text-xs text-muted-foreground hover:text-foreground hover:bg-muted rounded border border-transparent hover:border-border transition-all duration-200"
                >
                  {message}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* Status Preview */}
      <div className="p-4 bg-muted rounded-lg">
        <p className="text-xs font-medium text-muted-foreground mb-4">Status-Vorschau</p>
        
        <div className="grid md:grid-cols-2 gap-4">
          {/* Online Preview */}
          <div className="bg-card border border-border rounded-lg overflow-hidden">
            <div className="bg-success text-success-foreground px-3 py-2 flex items-center space-x-2">
              <Icon name="Circle" size={8} className="fill-current" />
              <span className="text-sm font-medium">Online</span>
            </div>
            <div className="p-3">
              <p className="text-sm text-foreground">
                {onlineMessage || "Wir sind online und bereit zu helfen!"}
              </p>
            </div>
          </div>

          {/* Offline Preview */}
          <div className="bg-card border border-border rounded-lg overflow-hidden">
            <div className="bg-muted text-muted-foreground px-3 py-2 flex items-center space-x-2">
              <Icon name="Circle" size={8} className="fill-current" />
              <span className="text-sm font-medium">Offline</span>
            </div>
            <div className="p-3">
              <p className="text-sm text-foreground">
                {offlineMessage || "Wir sind momentan offline"}
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Usage Tips */}
      <div className="p-3 bg-accent/10 border border-accent/20 rounded-lg">
        <div className="flex items-start space-x-2">
          <div className="w-4 h-4 rounded-full bg-accent flex-shrink-0 mt-0.5"></div>
          <div>
            <p className="text-sm font-medium text-accent-foreground">Tipps für Status-Nachrichten</p>
            <ul className="text-xs text-accent-foreground/80 mt-1 space-y-1">
              <li>• Online-Nachrichten sollten einladend und hilfsbereit sein</li>
              <li>• Offline-Nachrichten können Geschäftszeiten oder Rückrufzeiten erwähnen</li>
              <li>• Halten Sie beide Nachrichten kurz und prägnant</li>
              <li>• Verwenden Sie eine konsistente Tonalität mit Ihrer Marke</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusMessagesConfig;